import React from "react";

const ReadOnlyDocumentField = ({ label, value }) => (
  <dl className="document-readonly-field">
    <dt>{label}</dt>
    <dd>{value === null || value === undefined || value === "" ? "—" : value}</dd>
  </dl>
);

export default ReadOnlyDocumentField;
